import debug from 'debug';
import { queryString } from 'Global/Shared/Components/QueryString/QueryString';
import Authenticate from 'Minetilbud/Shared/Components/Api/Authenticate';

const log = debug('FrontPageCatalogs:Data:Favorites');
const authenticate = new Authenticate();

class Favorites {
	static dataset;
	static toggleUrl;
	static url;

	addFromQueryString(dataset) {
		const customerId = queryString.Get('favorite');
		if (customerId === null) return;

		const customers = dataset.filter(customer => customer.customerid === customerId);
		if (customers.length > 0) { 
			this.updateUrl();
			return dataset 
		};

		dataset.push({
			customerid: customerId,
			enabled: true,
			lastmmodified: new Date().toISOString()
		});
		
		this.set({
			customerId,
			enabled: true
		});

		this.updateUrl();

		return dataset;
	}

	/**
	 * @returns {Promise} favorites
	 */
	async get() {
		if (Favorites.dataset !== undefined) return Favorites.dataset;

		try {
			const profile = await authenticate.Profile();
			Favorites.toggleUrl = profile._links.favoritestoggle.href;
			Favorites.url = profile._links.favorites.href;

			let dataset = await authenticate.Url({
				method: 'get',
				url: '/api/v7/profile' + Favorites.url
			});

			if (queryString.Get('favorite')) {
				dataset = this.addFromQueryString(dataset);
			}

			Favorites.dataset = dataset;
			return dataset;
		} catch(error) {
			log('get() - error', error);
		}
	}

	/**
	 * @param {Object} options 
	 * @param {string} options.customerId
	 * @param {boolean} options.enabled 
	 */
	async set(options) {
		log('set()', options);
		try {
			const response = await authenticate.Url({
				body: {
					customerid: options.customerId,
					enabled: options.enabled,
					lastmmodified: new Date().toISOString()
				},
				method: 'put',
				url: '/api/v7/profile' + Favorites.toggleUrl.replace('{customerId}', options.customerId)
			});
			log('set()', response);
			return response;
		} catch (error) {
			log('get() - error', error);
		}
	}

	updateUrl() {
		const stateObj = { favorite: this.customerId };
		let url = location.pathname;

		queryString.Remove('favorite');

		const search = queryString.Search();

		if (search.length > 0) {
			url = url + '?' + search;
		}

		history.pushState(stateObj, '', url);
	}
}

export default Favorites;
